import { render, staticRenderFns } from "./boundlessFloor.vue?vue&type=template&id=090c1605&scoped=true"
import script from "./boundlessFloor.vue?vue&type=script&lang=js"
export * from "./boundlessFloor.vue?vue&type=script&lang=js"
import style0 from "./boundlessFloor.vue?vue&type=style&index=0&id=090c1605&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090c1605",
  null
  
)

export default component.exports